import React from "react";
import { FormFieldWrapper } from "./FormFieldWrapper";

// Creates a passed-in input component with a FormFieldWrapper
export const withFormField = (Input, type) => (props) =>
	// FormField = FormFieldWrapper + Input
	// FormFieldWrapper = LabelWrapper + Input
	// FormFieldWrapper handles distributing props to LabelWrapper and Input

	React.createElement(
		FormFieldWrapper,
		{ ...props },
		React.createElement(Input, { type })
	)
